
/****************************************** VIEW ALL BUTTON CLICK JS START *************************************/
let bundleVariantData=[];
$(document).ready(function () {
    $('.view-all-button').on('click', function () {
      var $collectionWrapper = $(this).closest('.collection-wrapper');
      $collectionWrapper.find('.collection-item.hide-product').removeClass('hide-product');
      $(this).hide();
      $(this).parent().find('.pro-collection-gallery').slick('refresh');
    });
    $('.collection-tabing-wrapper a').on('click', function () {
      $('.collection-tabing-wrapper a').removeClass('active');
      $(this).addClass('active');
    });
    
    sameBoxCard();

    var v1InterId = setInterval(() => {
        if(jQuery('.page-container').find('.bundle-builder-section.version-two').length>0){
            jQuery('.page-container').find('.bundle-builder-section.version-two').find('.pro-collection-gallery').slick('refresh');
            sameBoxCard();
            clearInterval(v1InterId);
        }
    }, 1000);
});
/****************************************** VIEW ALL BUTTON CLICK JS END ***************************************/

/************************************ PRODUCT COLOR VARAINT ACTIVE CLICK JS START ********************************/

jQuery(document).on("click",".grid-product__colors .color-swatch--with-image",function(){
    if(jQuery(this).parent().find(".color-swatch--with-image").length>0){
        jQuery(this).parent().find(".color-swatch--with-image").removeClass('active');
        jQuery(this).addClass('active');
    }
    var $productInfo = jQuery(this).closest('.product-info');
    var selectedVariantId = getVariantId($productInfo);
    var $quantitySelector = $productInfo.find('.quantity-selector');
    var $addButton = $productInfo.find('.product-btn');
    
    // Find variant in the bundle data array
    var variantData = false;
    if(selectedVariantId!="" && selectedVariantId!=undefined){
        variantData = bundleVariantData.find(function(item) {
            return item.variant_id == selectedVariantId;
        });
    }

    if(jQuery('.bundle-builder-section.version-one').length>0){
        if (variantData) {
            // Variant already in bundle → show quantity, hide add button
            $quantitySelector.show();
            $addButton.hide();

            // Set input to stored quantity
            $quantitySelector.find('.quantity-value').val(variantData.variant_quantity);
            $quantitySelector.find('.quantity-value').attr('data-variant-id',selectedVariantId);
        } else {
            // Variant not in bundle → show add button, hide quantity
            $quantitySelector.hide();
            $addButton.show();

            // Reset input to minimum
            var min = parseInt($quantitySelector.find('.quantity-value').attr('min')) || 1;
            $quantitySelector.find('.quantity-value').val(min);
        }
    }else if(jQuery('.bundle-builder-section.version-two').length>0){
        if (variantData) {
            // Variant already in bundle → show quantity, hide add button
            $quantitySelector.show();

            // Set input to stored quantity
            $quantitySelector.find('.quantity-value').val(variantData.variant_quantity);
        } else {
            // Variant not in bundle → show add button, hide quantity
            $quantitySelector.hide();

            // Reset input to minimum
            var min = parseInt($quantitySelector.find('.quantity-value').attr('min')) || 1;
            $quantitySelector.find('.quantity-value').val(min);
        }
    }
});

/************************************* PRODUCT COLOR VARAINT ACTIVE CLICK JS END *********************************/

/************************************ PRODUCT ADD TO BUNDLE AND BUTTON CLICK JS START **********************************/

jQuery(document).on("click",".bundle-builder-section .product-btn",function(){
    if(!jQuery('.bundle-builder-section').hasClass('version-one')){
        if(jQuery(this).parent().find('.product-variant-select').length>0){
            jQuery(this).parent().find('.product-variant-select').show();
            jQuery(this).hide();
        }
    }else{
        jQuery(this).parent().parent().find('.quantity-selector').css('display','flex');
        jQuery(this).hide();
        var obj = jQuery(this).closest('.product-info');
        var handleVariant = selectVariantGet(obj);
        //console.log("handleVariant",handleVariant);
        if(handleVariant!=undefined && handleVariant!=""){
            bundlePackHtml();
        }
    }
});

//Option Change Variant JS start
jQuery(document).on('change', ".bundle-builder-section.version-one .product-variant-select.dynamic-option", function() {
    var $productInfo = jQuery(this).closest('.product-info');
    var selectedVariantId = getVariantId($productInfo);
    var $quantitySelector = $productInfo.find('.quantity-selector');
    var $addButton = $productInfo.find('.product-btn');
    
    // Find variant in the bundle data array
    var variantData = false;
    if(selectedVariantId!="" && selectedVariantId!=undefined){
        variantData = bundleVariantData.find(function(item) {
            return item.variant_id == selectedVariantId;
        });
    }

    if (variantData) {
        // Variant already in bundle → show quantity, hide add button
        $quantitySelector.show();
        $addButton.hide();

        // Set input to stored quantity
        $quantitySelector.find('.quantity-value').val(variantData.variant_quantity);
    } else {
        // Variant not in bundle → show add button, hide quantity
        $quantitySelector.hide();
        $addButton.show();

        // Reset input to minimum
        var min = parseInt($quantitySelector.find('.quantity-value').attr('min')) || 1;
        $quantitySelector.find('.quantity-value').val(min);
    }
});

function getVariantId(buttonObj){
    if(buttonObj == undefined) return;
    var variantArray = [];
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });
    var colorSwatch = buttonObj.find('.grid-product__colors .color-swatch-ci.active');
    if(colorSwatch.length > 0){
        var colorVal = colorSwatch.attr('data-option');
        var colorValue = colorSwatch.attr('data-value');
        var colorImage = colorSwatch.attr('data-color-img');
        variantArray.push({ key: 'Color', value: colorVal,main_value:colorValue,'color_image':colorImage });
    }
    // Get dynamic selects
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(!jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });

    var variant_handle = variantArray.map(function(opt) {
        return opt.value;
    }).join('-');
    var variantId = '';
    if(variant_handle){
       variantId = buttonObj.find('.hidden-variant-select option[data-vhandle="'+variant_handle+'"]').val();
    }
    return variantId;
}

function calculateStrapTotals(bundleData) {
    let strapCount = 0;
    let totalPrice = 0;
    let totalComparePrice = 0;
    let strapCheck = 0;

    // --- Step 1: Count total straps ---
    for (const item of bundleData) {
        if (item) {
            const productTitle = item.product_title?.toLowerCase() || '';
            if (productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                strapCheck = 1;
                strapCount += parseInt(item.variant_quantity) || 0;
            }
        }
    }

    // --- Step 2: Determine paid vs free straps ---
    let paidStraps = 0;
    let freeStraps = 0;
    let strapBoxFree = 0;
    if (strapCount <= 1) {
        paidStraps = strapCount;
        freeStraps = 0;
        strapBoxFree=1;
    } else if (strapCount === 2) {
        paidStraps = 1; // Buy 1 Get 1 Free
        freeStraps = 1;
    } else if (strapCount === 3 || strapCount === 4) {
        paidStraps = 2;
        freeStraps = strapCount - 2;
    } else if (strapCount === 5) {
        paidStraps = 2; // Buy 2 Get 3 Free
        freeStraps = 3;
    } else if (strapCount === 6) {
        paidStraps = 3;
        freeStraps = 3;
        strapBoxFree=6;
    } else if (strapCount === 7) {
        paidStraps = 3;
        freeStraps = 4;
    } else if (strapCount >= 8) {
        paidStraps = strapCount - 4; // 4 free always after 7
        freeStraps = 4;
    }
    if(strapCount == 3){
        strapBoxFree=3;
    }

    console.log("freeStraps",freeStraps,strapCount);
    if(jQuery('.right-product-details-side.bundle-cart').find('.product-card.add-product-card').length>0){
        const $boxes = jQuery('.right-product-details-side.bundle-cart').find('.product-card.add-product-card');

        if((strapBoxFree == 1 || strapBoxFree==3 || strapBoxFree == 6) && strapCount>0){
            $boxes.show();
        }else {
            $boxes.hide();
        }
    }

    if(jQuery('.bundle-builder-section.version-two').find('.sticky-bundle-builder').find('.image-box.blank-card').length>0){
        var stickyBox = jQuery('.bundle-builder-section.version-two').find('.sticky-bundle-builder').find('.image-box.blank-card');
        if((strapBoxFree == 1 || strapBoxFree==3 || strapBoxFree == 6) && strapCount>0){
            stickyBox.show();
        }else {
            stickyBox.hide();
        }
    }
    // --- Step 3: Add total for only paid straps ---
    let processedCount = 0;

    for (const item of bundleData) {
        if (item) {
            const productTitle = item.product_title?.toLowerCase() || '';
            if (productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                const quantity = parseInt(item.variant_quantity) || 0;
                const price = parseFloat(item.variant_original_price || 0);
                const comparePrice = parseFloat(item.variant_original_cprice || 0);

                for (let q = 0; q < quantity; q++) {
                    processedCount++;
                    if (processedCount <= paidStraps) {
                        totalPrice += price;
                        totalComparePrice += comparePrice;
                    }
                }
            }
        }
    }

    return {
        strapCount,
        paidStraps,
        freeStraps,
        totalPrice,
        totalComparePrice,
        strapCheck
    };
}


function selectVariantGet(buttonObj){
    if(buttonObj == undefined) return;
    var variantArray = [];
    if(jQuery('.bundle-builder-section.version-two').length>0){
        buttonObj = buttonObj.next('.product-info');
        var colorSwatch = buttonObj.find('.grid-product__colors .color-swatch-ci.active');
    }else{
        var colorSwatch = buttonObj.find('.grid-product__colors .color-swatch-ci.active');
    }
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });
    
    if(colorSwatch.length > 0){
        var colorVal = colorSwatch.attr('data-option');
        var colorValue = colorSwatch.attr('data-value');
        var colorImage = colorSwatch.attr('data-color-img');
        variantArray.push({ key: 'Color', value: colorVal,main_value:colorValue,'color_image':colorImage });
    }
    // Get dynamic selects
    buttonObj.find('.product-variant-select.dynamic-option').each(function(){
        if(!jQuery(this).hasClass('version-variant')){
            var variant_option_val = $(this).find('option:selected').attr('data-option');
            var option_value = $(this).find('option:selected').attr('data-value');
            var variantKey = $(this).attr('data-option-name');
            variantArray.push({ key: variantKey, value: variant_option_val,main_value:option_value });
        }
    });

    var variant_handle = variantArray.map(function(opt) {
        if(opt.value!="" && opt.value!=undefined){
            return opt.value;
        }
    }).join('-');

    if(variant_handle){
        var quantityGet = 1;
        if(jQuery('.bundle-builder-section.version-two').length>0){
            console.log("buttonObj",buttonObj);
            var selectedVariant = buttonObj.parent().find('.hidden-variant-select option[data-vhandle="'+variant_handle+'"]');
            quantityGet = 1;
        }else if(jQuery('.bundle-builder-section.version-one').length>0){
            var selectedVariant = buttonObj.find('.hidden-variant-select option[data-vhandle="'+variant_handle+'"]');
            quantityGet = buttonObj.find('.quantity-value').val();
        }
        if(selectedVariant.length > 0){
            // Usage example:
            let variantId = selectedVariant.val();
            console.log("variantId",variantId);
            let index = findVariantIndex(bundleVariantData, variantId);
            console.log("index",index);
            if(jQuery('.bundle-builder-section.version-one').length>0){
                buttonObj.find('.quantity-selector').find('.quantity-value').attr('data-variant-id',variantId);
            }else if(jQuery('.bundle-builder-section.version-two').length>0){
                index = -1;
            }

            if (index !== -1) {
                bundleVariantData[index].variant_quantity = quantityGet;
            } else {
                bundleVariantData.push({
                    'variant_price': selectedVariant.attr('data-vprice'),
                    'variant_c_price': selectedVariant.attr('data-compare-vprice'),
                    'variant_original_price': selectedVariant.attr('data-original-vprice'),
                    'variant_original_cprice': selectedVariant.attr('data-original-compare-vprice'),
                    'variant_image': selectedVariant.attr('data-vimage'),
                    'variant_id': variantId,
                    'product_title': selectedVariant.attr('data-ptitle'),
                    'variant_handle': selectedVariant.attr('data-vhandle'),
                    'variant_option': variantArray,
                    'variant_quantity': quantityGet
                });
            }
            
        }
    }
    return variant_handle;
}

function findVariantIndex(array, variantId) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].variant_id === variantId) {
      return i; // return index if found
    }
  }
  return -1; // return -1 if not found
}


function bundlePackHtml() {
    var totalQuantity = 0 ;
    var totalComparePrice = 0;
    var totalPrice = 0;
    //console.log("bundleVariantData",bundleVariantData);
    if (bundleVariantData.length > 0) {
        if (jQuery('.right-product-details-side.bundle-cart').find('.cart-product-item-wrapper').length > 0) {
            jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .original-price.compare-sub-total').show();
            var $wrapper = jQuery('.right-product-details-side.bundle-cart').find('.cart-product-item-wrapper');
            if(jQuery('.bundle-builder-section.version-two').length>0){
                $wrapper =  jQuery('.bundle-builder-section.version-two');
                var variantHtmlBundle = '';
            }else if(jQuery('.bundle-builder-section.version-one').length>0){
                $wrapper.find('.product-card.blank-card').hide();
            }
            for (var j = 0; j < bundleVariantData.length; j++) {
                var variantId = bundleVariantData[j].variant_id;
                var variantQuantity = bundleVariantData[j].variant_quantity;
                var variantOriginlPrice = bundleVariantData[j].variant_original_price;
                var variantOriginlCPrice = bundleVariantData[j].variant_original_cprice;
                var variantImage = bundleVariantData[j].variant_image;
                var productTitle = bundleVariantData[j].product_title;
                var optionVariant = bundleVariantData[j].variant_option;
                var varaintPrice = bundleVariantData[j].variant_price;
                var varaintCPrice = bundleVariantData[j].variant_c_price;

                if(jQuery('.bundle-builder-section.version-one').length>0){
                    var $existingProduct = $wrapper.find('.product-card').not('.add-product-card').filter(function () {
                        return jQuery(this).data('variant-id') == variantId;
                    });
                    if(jQuery('.right-product-details-side.bundle-cart').find('.product-card[data-variant-id="'+variantId+'"]').length>0 && variantQuantity>1){
                        jQuery('.right-product-details-side.bundle-cart').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .minus-icon').show();
                        jQuery('.right-product-details-side.bundle-cart').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .remove-icon').hide();
                    }else{
                        jQuery('.right-product-details-side.bundle-cart').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .minus-icon').hide();
                        jQuery('.right-product-details-side.bundle-cart').find('.product-card[data-variant-id="'+variantId+'"]').find('.quantity-btn .remove-icon').show();
                    }
                    if ($existingProduct.length) {
                        // Update quantity only
                        $existingProduct.find('.quantity-input').val(variantQuantity);
                    } else {
                        // Build new HTML
                        var variantHtmlBundle = '';
                        variantHtmlBundle += '<div class="product-card" data-variant-id="' + variantId + '"><div class="product-image">';
                        variantHtmlBundle += '<img src="' + variantImage + '"></div>';
                        variantHtmlBundle += '<div class="product-info"><h3 class="product-title">' + productTitle + '</h3>';
                        variantHtmlBundle += '<div class="product-options">';

                        for (var g = 0; g < optionVariant.length; g++) {
                            if (optionVariant[g].key != undefined) {
                                var keyval = optionVariant[g].key.toLowerCase();
                                if (keyval != 'version') {
                                    var value_option = optionVariant[g].main_value;
                                    if (keyval == 'color') {
                                        var colorImg = optionVariant[g].color_image;
                                        variantHtmlBundle += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                                        variantHtmlBundle += '<span class="color--swatch"><img src="' + colorImg + '"></span>';
                                        variantHtmlBundle += '<span class="option-value">' + value_option + '</span></div>';
                                    } else {
                                        variantHtmlBundle += '<div class="option-row"><span class="option-label ' + keyval + '">' + optionVariant[g].key + ':</span>';
                                        variantHtmlBundle += '<span class="option-value">' + value_option + '</span></div>';
                                    }
                                }
                            }
                        }
                        variantHtmlBundle += '</div>';
                        variantHtmlBundle += '<div class="product-pricing-quantity-wrapper"><div class="product-pricing">';
                        if (varaintCPrice != "" && varaintCPrice != undefined) {
                            variantHtmlBundle += '<span class="price-original">' + varaintCPrice + '</span>';
                        }
                        variantHtmlBundle += '<span class="price-sale">' + varaintPrice + '</span></div>';
                        variantHtmlBundle += '<div class="quantity-control"><button class="quantity-btn minus bundle-picker">';
                        variantHtmlBundle += '<svg class="minus-icon" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M0.555542 4.5H9.44421V5.5H0.555542V4.5Z" fill="black"/></svg>';
                        variantHtmlBundle += '<svg class="remove-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">';
                        variantHtmlBundle += '<path d="M1.75 3.50002H12.25M11.0833 3.50002V11.6667C11.0833 11.9761 10.9604 12.2729 10.7416 12.4916C10.5228 12.7104 10.2261 12.8334 9.91667 12.8334H4.08333C3.77391 12.8334 3.47717 12.7104 3.25838 12.4916C3.03958 12.2729 2.91667 11.9761 2.91667 11.6667V3.50002M4.08333 3.50002L5.25 1.16669H8.75L9.91667 3.50002" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>';
                        variantHtmlBundle += '</svg>';
                        variantHtmlBundle += '</button><input type="number" class="quantity-input quantity-value" data-variant-id="'+variantId+'" value="' + variantQuantity + '" min="1" pattern="[0-9]*">';
                        variantHtmlBundle += '<button class="quantity-btn plus bundle-picker"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">';
                        variantHtmlBundle += '<path d="M5.49988 4.49988H9.44421V5.49988H5.49988V9.44421H4.49988V5.49988H0.555542V4.49988H4.49988V0.555542H5.49988V4.49988Z" fill="black"/>';
                        variantHtmlBundle += '</svg></button></div></div></div></div>';
                        
                        $wrapper.find('.product-card.add-product-card').first().before(variantHtmlBundle);
                    }
                }else if(jQuery('.bundle-builder-section.version-two').length>0){
                    variantHtmlBundle += '<div class="image-box image-added" data-variant-id="'+variantId+'"><div class="close-icon">';
                    variantHtmlBundle += '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none"><path d="M4.8687 3.32087L7.26209 5.71427L6.39339 6.58296L4 4.18957L1.60592 6.58365L0.737231 5.71496L3.13131 3.32087L0.73654 0.926103L1.60523 0.0574113L4 2.45218L6.39409 0.0581018L7.26278 0.926794L4.8687 3.32087Z" fill="white"/>';
                    variantHtmlBundle += '</svg></div><img src="' + variantImage + '" alt="'+productTitle+'">';
                    variantHtmlBundle += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.75 7.25H16V8.75H8.75V16H7.25V8.75H0V7.25H7.25V0H8.75V7.25Z" fill="black"/>';
                    variantHtmlBundle += '</svg></div>';
                    
                    if($wrapper.find('.sticky-bundle-builder').length>0){
                        $wrapper.find('.bundle-form').find('.product-variant-select.dynamic-option').val("");
                        $wrapper.find('.bundle-form').find('.product-variant-select.dynamic-option').hide();
                        $wrapper.find('.bundle-form').find('.product-btn').show();
                    }
                }
                totalQuantity+=parseInt(variantQuantity);
                totalPrice+=(parseInt(variantOriginlPrice)*variantQuantity);
                totalComparePrice+=(parseInt(variantOriginlCPrice)*variantQuantity);
            }
            if(jQuery('.bundle-builder-section.version-two').find('.sticky-bundle-builder').length>0 && variantHtmlBundle!=""){
                variantHtmlBundle += v2blankBoxHtml();
                $wrapper.find('.sticky-bundle-builder').find('.image-boxes').html('');
                $wrapper.find('.sticky-bundle-builder').find('.image-boxes').html(variantHtmlBundle);
            }
        }
        //console.log("totalQuantity",totalQuantity);
        
    }else{
        if(jQuery('.bundle-builder-section.version-one').length>0){
            jQuery('.bundle-builder-section.version-one').find('.product-card.blank-card').show();
        }
    }
    const totals = calculateStrapTotals(bundleVariantData);
    //console.log("Strap count (includes free):", totals.strapCount);
    totalPrice = totals.totalPrice;
    totalComparePrice = totals.totalComparePrice;
    //console.log("Strap exists?", totals.strapCheck);

    if(jQuery('.bundle-builder-section.version-one').length>0){
        if(jQuery('.right-product-details-side.bundle-cart').find('.cart-count').length>0){
            jQuery('.right-product-details-side.bundle-cart').find('.cart-count').text(totalQuantity);
        }
        if(jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .price-value').length>0){
            totalComparePrice = theme.Currency.formatMoney(totalComparePrice,theme.settings.moneyFormat);
            totalPrice = theme.Currency.formatMoney(totalPrice,theme.settings.moneyFormat);

            jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .original-price.compare-sub-total').text(totalComparePrice);
            jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .current-price.sub-total').text(totalPrice);
        }
    }else if(jQuery('.bundle-builder-section.version-two').length>0){
        if(jQuery('.bundle-builder-section.version-two').find('.price-info .current-price.sub-total').length>0){
            var savingPrice = 0;
            if(totalComparePrice!=0 && parseInt(totalComparePrice)>parseInt(totalPrice)){
                savingPrice = (parseInt(totalComparePrice)-parseInt(totalPrice));
            }
            if(savingPrice>0){
                jQuery('.bundle-builder-section.version-two').find('.price-column').find('.original-price.compare-sub-total').show();
                jQuery('.bundle-builder-section.version-two').find('.price-column').find('.savings').show();
                savingPrice = theme.Currency.formatMoney(savingPrice,theme.settings.moneyFormat);
                if(jQuery('.bundle-builder-section.version-two').find('.price-column .savings').length>0){
                    jQuery('.bundle-builder-section.version-two').find('.price-column .savings span').text(savingPrice);
                }
            }else{
                jQuery('.bundle-builder-section.version-two').find('.price-column').find('.original-price.compare-sub-total').hide();
                jQuery('.bundle-builder-section.version-two').find('.price-column').find('.savings').hide();
            }
            totalComparePrice = theme.Currency.formatMoney(totalComparePrice,theme.settings.moneyFormat);
            totalPrice = theme.Currency.formatMoney(totalPrice,theme.settings.moneyFormat);

            jQuery('.bundle-builder-section.version-two').find('.price-info .original-price.compare-sub-total').text(totalComparePrice);
            jQuery('.bundle-builder-section.version-two').find('.price-info .current-price.sub-total').text(totalPrice);
        }
    }
    bundleBuilderProgress();
}

//TOTAL PRICE CALCULATION JS END

//PRODUCT COLLECTION QUANTITY PICKER JS START
function setValue(newVal,$input) {
    var min = parseInt($input.attr('min')) || 1;
    var max = parseInt($input.attr('max')) || null;
    if (newVal < min) newVal = min;
    if (max && newVal > max) newVal = max;
    $input.val(newVal).trigger('change');
}
jQuery(document).on("click", ".bundle-builder-section.version-one .quantity-btn.plus", function () {
    var $btn = jQuery(this);
    var $selector = $btn.parent();
    var $input = $selector.find('.quantity-value');
    var current = parseInt($input.val()) || 0;
    var variantId = parseInt($input.attr('data-variant-id'));
    var obj;

    if (!variantId) return; // safety check

    // Increase current value
    var newVal = current + 1;
    $input.val(newVal).trigger("change");

    // If it's a bundle picker button
    if ($btn.hasClass('bundle-picker')) {
        // Update all same variant inputs in all sections
        jQuery('.bundle-builder-section')
            .find('.quantity-selector .quantity-value[data-variant-id="' + variantId + '"]')
            .each(function () {
                jQuery(this).val(newVal).trigger("change");
                // Show the selector if hidden
                jQuery(this).parent().show();
                jQuery(this).parent().parent().next('.product-btn').hide();
            });
    }

    // Update bundleVariantData
    var variantIndex = bundleVariantData.findIndex(function (item) {
        return item.variant_id == variantId;
    });
    if (variantIndex > -1) {
        bundleVariantData[variantIndex].variant_quantity = newVal;
    } else {
        bundleVariantData.push({
            variant_id: variantId,
            variant_quantity: newVal
        });
    }

    // Reference current product info for rendering
    obj = $btn.closest('.product-info');
    if (obj && obj.length) {
        var handleVariant = selectVariantGet(obj);
        setTimeout(function () {
            bundlePackHtml();
        }, 100);
    }
});

jQuery(document).on("click",".bundle-builder-section.version-one .quantity-btn.minus",function (){
    var $selector = jQuery(this).parent();
    var $input = $selector.find('.quantity-value');
    var current = parseInt($input.val()) || 1;

    var variantId = parseInt($input.attr('data-variant-id'));

    if (!variantId) return; // safety check

    if (current == 1) {
        // Hide quantity selector and show add button
        $selector.hide();
        $selector.parent().find('.product-btn').show();

        // Remove from bundleVariantData array
        bundleVariantData = bundleVariantData.filter(function(item) {
            return item.variant_id != variantId;
        });

        // Remove from cart HTML
        jQuery('.right-product-details-side.bundle-cart')
            .find('.cart-product-item-wrapper .product-card')
            .filter(function() {
                return jQuery(this).data('variant-id') == variantId;
            }).remove();
        
        if(jQuery('.right-product-details-side.bundle-cart').find('.cart-product-item-wrapper .product-card:not(.add-product-card)').length === 0) {
            jQuery('.right-product-details-side.bundle-cart').find('.cart-count').text(0);
        }
        if(jQuery(this).hasClass('bundle-picker')){
            if(jQuery('.bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').length>0){
                jQuery('.bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').parent().hide();
                jQuery('.bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').parent().parent().find('.product-btn').show();
            }
        }
        if(bundleVariantData.length==0){
            var comparePrice = theme.Currency.formatMoney(0,theme.settings.moneyFormat);
            var tprice = theme.Currency.formatMoney(0,theme.settings.moneyFormat);
            jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .original-price.compare-sub-total').hide();
            jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .current-price.sub-total').text(tprice);
        }
    } else {
        // Decrease normally
        var newVal = current - 1;
        if (newVal < 1) newVal = 1;
        $input.val(newVal).trigger('change');

        // Update variant quantity in array
        var variantIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == variantId;
        });
        if (variantIndex > -1) {
            bundleVariantData[variantIndex].variant_quantity = newVal;
        }
        if(jQuery(this).hasClass('bundle-picker')){
            if(jQuery('.bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').length>0){
                jQuery('.bundle-builder-section').find('.collection-item').find('.quantity-selector .quantity-value[data-variant-id="'+variantId+'"]').val(newVal);
            }
        }

        // Refresh HTML
    }
    setTimeout(function(){
        bundlePackHtml();
    },100);
});
//PRODUCT COLLECTION QUANTITY PICKER JS END

//PACK BUILDER PROGRESSBAR JS START
function bundleBuilderProgress(){
    let chkFlashCode = "";
    let chkFlashCodeTitle = "";
    let chkDiscountType = "";
    let strapCheck = 0;
    let productCount = 0;
    let countProduct = 0;
    let items_subtotal=0;
    var defaultProgress = 0;
    if(bundleVariantData.length > 0) {
        const totals = calculateStrapTotals(bundleVariantData);

        //console.log("Strap count (includes free):", totals.strapCount);
        totalPrice = totals.totalPrice;
        totalComparePrice = totals.totalComparePrice;
        //jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container').show();
        for (var i = 0; i < bundleVariantData.length; i++) { 
            if (bundleVariantData[i] != undefined) {
                var productTitle = bundleVariantData[i].product_title.toLowerCase();
                if(productTitle && productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                    strapCheck = 1;
                    productCount+=parseInt(bundleVariantData[i].variant_quantity);
                    items_subtotal+=parseInt(bundleVariantData[i].variant_original_price);
                }
            }
            let freeShippingPrice = 80;
            let freeShippingProgressTarget = 80;
            let subtotal = (totalPrice/100);

            var conversionRate = Shopify.currency.rate || 1;
            freeShippingProgressTarget = Math.round(freeShippingProgressTarget * conversionRate);

            console.log("freeShippingProgressTarget",freeShippingProgressTarget);
            let freeship = Math.round((subtotal * 100) / freeShippingProgressTarget);
            if (freeship > 100) freeship = 100;
            if(jQuery('.bundle-builder-section.version-one').length>0){
                var goal1 = 5;
                var goal3 = 7;
                productCount = parseInt(productCount);
                jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').addClass('locked');
                if (productCount > 0) {
                    var discountFlashBuy = "1";
                    var discountFlashFree = " 1 "; 
                    var discountMoreStrap = 1;
                    var discountStraps = 1;
                    if(productCount>1){
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').length>0){
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').eq(0).removeClass('locked');
                        }
                        if(productCount>=2 && productCount<5){
                            discountFlashBuy = "2";
                            discountFlashFree = " 3 "; 
                            var remaincount = (goal1-productCount);
                            discountMoreStrap = remaincount;
                            discountStraps = remaincount;
                        }else if (productCount>=5 && productCount<7) {
                            discountFlashBuy = "3";
                            discountFlashFree = " 4 "; 
                            var remaincount = (goal3-productCount);
                            discountMoreStrap = remaincount;
                            discountStraps = remaincount;
                            if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').length>0){
                                jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').eq(0).removeClass('locked');
                                jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').eq(1).removeClass('locked');
                            }
                        }else if(productCount>=7){
                            discountFlashBuy = "";
                            discountFlashFree = ""; 
                            discountMoreStrap = '';
                            discountStraps = '';
                            if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').length>0){
                                jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').eq(0).removeClass('locked');
                                jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').eq(1).removeClass('locked');
                                jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').eq(2).removeClass('locked');
                            }
                        }
                    }
                    if(discountMoreStrap!=""){
                        if(discountMoreStrap>1){
                            discountMoreStrap=discountMoreStrap+ ' more straps';
                        }else{
                            discountMoreStrap =discountMoreStrap+ ' more strap';
                        }
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container').length>0){
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .count-strap').text(discountMoreStrap);
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .strap-free').text(discountFlashFree);
                        }
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .starp-text-message').length>0){
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .starp-text-message').show();
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .starp-text-message-congrats').hide();
                            
                        }
                        //jQuery('.right-product-details-side.bundle-cart').find('.product-card.add-product-card').show();
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .count-strap').length>0){
                           jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .charcter-msg').text(' and');
                        }
                    }else{
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .starp-text-message').length>0){
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .starp-text-message').hide();
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .starp-text-message-congrats').show();
                            //jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .free-shipping-row').show();
                        }
                        jQuery('.right-product-details-side.bundle-cart').find('.product-card.add-product-card').hide();
                    }
                    if(freeship>=100){
                        jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .free-shipping-row').show();
                    }else{
                        jQuery('.right-product-details-side.bundle-cart').find('.bundle-cart-footer .free-shipping-row').hide();
                    }
                    var goal1 = 5;
                    var goal3 = 7;
                    var progressPercent = 0;
                    var statusText = "";
                    if(productCount>1){
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-line').length>0){
                            if (productCount < goal1) {
                                progressPercent = (productCount / goal3) * 100;
                                if(progressPercent>50){
                                    progressPercent = 48;
                                }
                                if(productCount >= 2){
                                    progressPercent = (progressPercent-10);
                                }
                            }else if (productCount === goal1) {
                                progressPercent = (goal1 / goal3) * 100;
                            }else if (productCount > goal1 && productCount < goal3) {
                                progressPercent = (productCount / goal3) * 100;
                                progressPercent=(progressPercent-10);
                            }else if (productCount >= goal3) {
                                progressPercent = 100;
                            }
                        }
                        //console.log("progressPercent",progressPercent,productCount);
                        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-line-fill').length>0){
                            progressPercent = Math.round(progressPercent);
                            jQuery('.right-product-details-side.bundle-cart').find('.progress-line-fill').css('width',progressPercent+'%');
                        }
                        if(defaultProgress==1 && jQuery('.cart__drawer').find('.multi-step-form-default').length>0){
                            jQuery('.cart__drawer').find('.multi-step-form-default').removeAttr('style');
                        }
                    }else{
                        jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').addClass('locked');
                        jQuery('.right-product-details-side.bundle-cart').find('.progress-line-fill').css('width','0%');
                    }
                }
            }else if(jQuery('.bundle-builder-section.version-two').length>0){
                if(jQuery('.bundle-builder-section.version-two').find('.price-info').find('.free-shipping').length>0){
                    if(freeship>=100){
                        jQuery('.bundle-builder-section.version-two').find('.price-info').find('.free-shipping').show();
                    }else{
                        jQuery('.bundle-builder-section.version-two').find('.price-info').find('.free-shipping').hide();
                    }
                }
            }
        }
    }else{
        jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .step').addClass('locked');
        jQuery('.right-product-details-side.bundle-cart').find('.progress-line-fill').css('width','0%');
        //jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container').hide();
        if(jQuery('.bundle-builder-section.version-two').length>0){
            jQuery('.bundle-builder-section.version-two').find('.price-column').find('.original-price.compare-sub-total').hide();
            jQuery('.bundle-builder-section.version-two').find('.price-column').find('.savings').hide();
        }
        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .count-strap').length>0){
            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .charcter-msg').text(',');
        }
        if(jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container').length>0){
            var discountMoreStrap =  '1 strap';
            jQuery('.right-product-details-side.bundle-cart').find('.progress-stepper-container .count-strap').text(discountMoreStrap);
        }
        if(jQuery('.right-product-details-side.bundle-cart').find('.product-card.add-product-card').length>0){
            jQuery('.right-product-details-side.bundle-cart').find('.product-card.add-product-card').hide();
        }
    }
}

//BUNDLE PACK SELECTED TO ADD TO CART JS START 
jQuery(document).on("click",".bundle-builder-section .checkout-button",function(){
    bundlePackAddToCart();
});
function bundlePackAddToCart(){
    if(bundleVariantData.length > 0) {
        if(jQuery(".bundle-builder-section .checkout-button").length>0){
            jQuery(".bundle-builder-section .checkout-button").addClass('btn--loading');
        }
        //console.log("productTitle",bundleVariantData);
        var itemArr=[];
        for (var i = 0; i < bundleVariantData.length; i++) { 
            if (bundleVariantData[i] != undefined) {
                var productTitle = bundleVariantData[i].product_title.toLowerCase();
                var variantQuantity = parseInt(bundleVariantData[i].variant_quantity);
                var variantId = parseInt(bundleVariantData[i].variant_id);
                itemArr.push({
                    id: variantId,
                    quantity: variantQuantity,
                    properties: {'__single_bundle':1}
                });
            }
        }
        if(itemArr.length>0){
            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({ items: itemArr }),
                success: function (n) {
                    window.location.href="/checkout";
                },
                error: function (n, c) {
                    if(jQuery(".bundle-builder-section .checkout-button").length>0){
                        jQuery(".bundle-builder-section .checkout-button").removeClass('btn--loading');
                    }
                    console.log('fail');
                }
            });
        }
    }
}
function sameBoxCard() {
  jQuery('.bundle-builder-section .collection-wrapper').each(function () {
    var $wrapper = jQuery(this);
    var $section = $wrapper.closest('.bundle-builder-section');
    var widthVersion = 0;
    var winWidth = jQuery(window).width();

    if ($section.hasClass('version-one')) {
      if (winWidth >= 1250) {
        widthVersion = 3;
      } else if (winWidth < 1250 && winWidth > 900) {
        widthVersion = 2;
      } else if (winWidth <= 900 && winWidth > 600) {
        widthVersion = 3;
      } else if (winWidth <= 600) {
        widthVersion = 2;
      }
    } else if ($section.hasClass('version-two')) {
      if(winWidth > 900) {
        widthVersion = 4;
      } else if (winWidth <= 900 && winWidth > 600) {
        widthVersion = 2;
      }
    }

    var $cards = $wrapper.find('.product-info');
    if ($cards.length > 0) {
      // Reset heights before recalculating
      $cards.find('.product-title, .jdgm-preview-badge, .color-variant, .other-options').css('height', 'auto');

      for (var i = 0; i < $cards.length; i += widthVersion) {
        var $rowItems = $cards.slice(i, i + widthVersion);

        // Helper function to set equal height for row elements
        function setMaxHeight(selector) {
          var maxHeight = 0;
          $rowItems.each(function () {
            var $el = jQuery(this).find(selector);
            if ($el.length) {
              var h = $el.outerHeight();
              if (h > maxHeight) maxHeight = h;
            }
          });

          // Special case for review badge
          if (selector === '.jdgm-preview-badge') {
            if (maxHeight > 0) {
              $rowItems.each(function () {
                var $badge = jQuery(this).find('.jdgm-preview-badge');
                if ($badge.length) {
                  $badge.css('height', maxHeight);
                } else {
                  // Add invisible placeholder for missing reviews
                  jQuery(this)
                    .find('.product-title')
                    .after('<div class="jdgm-preview-badge" style="visibility:hidden;height:' + maxHeight + 'px;"></div>');
                }
              });
            }
          } else {
            if (maxHeight > 0) $rowItems.find(selector).css('height', maxHeight);
          }
        }

        // Apply equal heights for all key elements
        setMaxHeight('.product-title');
        setMaxHeight('.jdgm-preview-badge');
        setMaxHeight('.color-variant');
        setMaxHeight('.other-options');
      }
    }
  });
}

// Run on load and resize
jQuery(document).ready(function () {
  //sameBoxCard();
  jQuery(window).on('resize', function () {
    sameBoxCard();
  });
});



// VERSION  - V2 JS START HERE
jQuery(document).on('change',".bundle-builder-section.version-two .product-variant-select",function(){
    var obj = jQuery(this).parent().parent();
    var handleVariant = selectVariantGet(obj);
    //console.log("handleVariant",handleVariant);
    if(handleVariant!=undefined && handleVariant!=""){
        bundlePackHtml();
    }
});

jQuery(document).on('click',".bundle-builder-section.version-two .image-added .close-icon",function(){
    var getVariantId = jQuery(this).parent().attr('data-variant-id');
    if(getVariantId!=undefined && getVariantId!=""){
        jQuery(this).parent().remove();
        var variantIndex = bundleVariantData.findIndex(function(item) {
            return item.variant_id == getVariantId;
        });

        if (variantIndex !== -1) {
            bundleVariantData.splice(variantIndex, 1); 
        }
        bundlePackHtml();
    }
});

function v2blankBoxHtml(){
    if(jQuery('.bundle-builder-section.version-two').find('.sticky-bundle-builder').find('.image-box:not(.image-added)').length>0){
        jQuery('.bundle-builder-section.version-two').find('.sticky-bundle-builder').find('.image-box:not(.image-added)').remove();
    }
    var htmlBox='';
    htmlBox+='<div class="image-box blank-card"><div class="close-icon">';
    htmlBox+='<svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none">';
    htmlBox+='<path d="M4.8687 3.32087L7.26209 5.71427L6.39339 6.58296L4 4.18957L1.60592 6.58365L0.737231 5.71496L3.13131 3.32087L0.73654 0.926103L1.60523 0.0574113L4 2.45218L6.39409 0.0581018L7.26278 0.926794L4.8687 3.32087Z" fill="white"/>';
    htmlBox+='</svg></div><img src="https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=200&h=200&fit=crop" alt="Product 2">';
    htmlBox+='<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.75 7.25H16V8.75H8.75V16H7.25V8.75H0V7.25H7.25V0H8.75V7.25Z" fill="black"/></svg></div>';
    return htmlBox;
}
// VERSION  - V2 JS END HERE
/************************************ PRODUCT ADD TO BUNDLE AND BUTTON CLICK JS END **********************************/